export const UI_TEXT = {
	INITIAL_DISPLAY: "Unit Conversions",
	CALCULATOR_TITLE: "CX-3 FLIGHT COMPUTER",

	E6B_LABEL: "E6-B",
	DEFAULT_TIME: "00:00",
	BATTERY_LABEL: "BATT",
	NO_MENU_ITEMS: "No menu items available",
	INPUT_LABEL: "Input: ",
	MEMORY_LABEL: "M: ",

	ERROR_INVALID_NUMBER: "Error: Invalid number",
	ERROR_DIVISION_BY_ZERO: "Error: Division by zero",
	ERROR_INVALID_RESULT: "Error: Invalid result",

	DECIMAL_POINT: "0.",

	BUTTONS: {
		FLT: "FLT",
		PLAN: "PLAN",
		UP_ARROW: "▲",
		TIMER: "TIMER",
		CALC: "CALC",
		BACK: "BACK",
		STAR: "★",
		WIND: "WIND",
		WEIGHT_BALANCE: "W/B",
		SET: "SET",
		MEMORY: "M",
		SET_UNIT: "SET\nUNIT",
		DOWN_ARROW: "▼",
		CONV_UNIT: "CONV\nUNIT",
		DIVIDE: "÷",
		CLEAR: "C",
		MULTIPLY: "×",
		BACKSPACE: "BKSP",
		MINUS: "−",
		COLON: "M−",
		PLUS: "+",
		PLUS_MINUS: "±",
		DOT: ".",
		CHECKMARK: "✓",
		EQUALS: "=",
		ZERO: "0",
		ONE: "1",
		TWO: "2",
		THREE: "3",
		FOUR: "4",
		FIVE: "5",
		SIX: "6",
		SEVEN: "7",
		EIGHT: "8",
		NINE: "9",
	},
} as const;

export const BUTTON_ROW_NAMES = [
	"navigation",
	"function",
	"mode",
	"number1",
	"number2",
	"number3",
	"bottom",
] as const;

export const METERS_PER_FOOT = 0.3048;
export const MPH_PER_KT = 1.150779448; // 1 kt = 1.150779448 mph
export const KM_PER_NM = 1.852; // 1 NM = 1.852 km
export const LITERS_PER_GALLON = 3.785411784; // 1 US gal = 3.785411784 L

// Aviation domain constants (keep centralized for easy tuning)
export const AVGAS_LB_PER_GAL = 6.0; // typical AvGas weight
export const GENERIC_FUEL_LB_PER_GAL = 6.8; // generic fuel weight used in app
export const AVGAS_KG_PER_L = 0.72; // approx density (kg/L)
export const USABLE_FUEL_FACTOR = 0.95; // for total usable fuel calc
export const BURN_RATE_GPH = 8.5; // example burn rate (gal/hr)

export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;
export const normalize360 = (deg: number) => ((deg % 360) + 360) % 360;
